module.exports = __webpack_public_path__ + "img/robot.f2a9d808.png";